import Tab from '@mui/material/Tab';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { tabStyle } from 'src/common/components/AppLayout/AppLayout.styles';
import { a11yTabProps } from 'src/common/components/AppLayout/Components/utils';
import { useProductSummaryAvailable } from '../productsSummary/hooks/useProductSummaryAvailable';
import { Routes } from 'src/Routes.constants';
import { useTariffSummaryAvailable } from 'products/tariffSummary/hooks/useTariffSummaryAvailable';
import { useSimProductUrlFromFilters } from '../sim/hooks/useSimProductUrlFromFilters';
import { useRSimProductUrlFromFilters } from 'src/rSimInventory/hooks/useRSimUrlFromFilters';
import { useTariffSummaryUrlFromFilters } from 'products/tariffSummary/hooks/useTariffSummaryUrlFromFilters';
import { TabsLayout } from 'src/common/components/Layouts/TabsLayout/TabsLayout';
import { useESimProductUrlFromFilters } from '../esim/hooks/useESimUrlFromFilters';
import { useESimsAvailable } from '../esim/hooks/useESimAvailable';

export const ProductsTabs = ({ children }: { children: React.ReactNode }) => {
  const tariffSummaryViewEnabled = useTariffSummaryAvailable();
  const productSummaryViewEnabled = useProductSummaryAvailable();
  const eSimsEnabled = useESimsAvailable();

  const { t } = useTranslation();

  const tariffSummaryUrl = useTariffSummaryUrlFromFilters();
  const simProductUrl = useSimProductUrlFromFilters();
  const rsimProductUrl = useRSimProductUrlFromFilters();
  const esimProductUrl = useESimProductUrlFromFilters();

  return (
    <TabsLayout content={children}>
      {productSummaryViewEnabled && (
        <Tab
          sx={tabStyle}
          value={Routes.productSummary}
          label={t('productSummary.productSummary')}
          component={Link}
          to={Routes.productSummary}
          {...a11yTabProps(t('productSummary.productSummary'))}
        />
      )}
      {tariffSummaryViewEnabled && (
        <Tab
          sx={tabStyle}
          value={Routes.tariffSummary}
          label={t('tariffSummary.tariffSummary')}
          component={Link}
          to={tariffSummaryUrl}
          {...a11yTabProps(t('tariffSummary.tariffSummary'))}
        />
      )}
      <Tab
        sx={tabStyle}
        value={Routes.productsSim}
        label="SIM"
        component={Link}
        to={simProductUrl}
        {...a11yTabProps('SIM')}
      />
      <Tab
        sx={tabStyle}
        value={Routes.productsRsim}
        label="rSIM"
        component={Link}
        to={rsimProductUrl}
        {...a11yTabProps('rSIM')}
      />
      {eSimsEnabled && (
        <Tab
          sx={tabStyle}
          label="eSIM"
          component={Link}
          value={Routes.esim}
          to={esimProductUrl}
          {...a11yTabProps('eSIM')}
        />
      )}
    </TabsLayout>
  );
};
